import { render } from "./HomePremiumServices.vue?vue&type=template&id=b11822fa"
import script from "./HomePremiumServices.vue?vue&type=script&lang=js"
export * from "./HomePremiumServices.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__